<template>
  <div class="Safe">
    <transition
      name="el-zoom-in-center"
      mode="out-in"
    >
      <section
        v-if="$store.state.nowPage === ''"
        class="main-section"
      >
        <div style="text-align:center">
          <h1 class="main-title">
            交通安全宣導
          </h1>
          <span class="phone-tips">(左右滑動選擇當前狀況)</span>
          <br>
          <el-row
            :gutter="20"
            class="row"
          >
            <el-col
              :sm="12"
              :xs="24"
            >
              <el-card
                :body-style="{ padding: '0px' }"
                style="width:100%;"
              >
                <h1 class="card-title">
                  交通安全宣導影片
                </h1>
                <img
                  src="@/assets/online_school_boy.png"
                  class="image"
                  style="width: 100%;display: block;"
                  @click="changePage('L')"
                >
                <div style="padding: 14px 0px;">
                  <div class="bottom">
                    <el-button
                      size="medium"
                      type="primary"
                      class="button"
                      round
                      @click="changePage('L')"
                    >
                      了解下一步該怎麼做
                    </el-button>
                  </div>
                </div>
              </el-card>
            </el-col>
            <el-col
              :sm="12"
              :xs="24"
            >
              <el-card
                :body-style="{ padding: '0px' }"
                style="width:100%;"
              >
                <h1 class="card-title">
                  相關法規
                </h1>
                <img
                  src="@/assets/book_law_hou.png"
                  class="image"
                  style="width: 100%;display: block;"
                  @click="changePage('M')"
                >
                <div style="padding: 14px 0px;">
                  <div class="bottom">
                    <el-button
                      size="medium"
                      type="primary"
                      class="button"
                      round
                      @click="changePage('M')"
                    >
                      了解下一步該怎麼做
                    </el-button>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </section>
      <section
        v-else-if="$store.state.nowPage != ''"
        class="main-section"
      >
        <div>
          <el-breadcrumb
            separator="/"
            class="breadcrumb"
          >
            <el-breadcrumb-item :to="{ path: '/' }">
              首頁
            </el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/safe' }">
              交通安全宣導
            </el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/safe' }">
              {{ filteredPageData[0].title }}
            </el-breadcrumb-item>
            <el-breadcrumb-item>
              {{ $store.state.nowPagetitle }}
            </el-breadcrumb-item>
          </el-breadcrumb>
          <el-button
            type="primary"
            @click="$router.push('/safe')"
          >
            上一步
          </el-button>
          <el-row
            :gutter="30"
            class="inpage"
          >
            <el-col
              :sm="6"
              :xs="24"
            >
              <div
                class="affix-container"
                style="height:calc(100% - 50px);box-sizing: border-box;"
              >
                <el-affix
                  :target="affixPhoneFix"
                  :offset="80"
                >
                  <el-button
                    v-for="(page, index) in filteredPageData"
                    :key="index"
                    class="page-sidebar"
                    @click="changeSubPage(page.link, page.text)"
                  >
                    <span> {{ page.text }}</span>
                  </el-button>
                </el-affix>
              </div>
            </el-col><br>
            <el-col
              :sm="18"
              :xs="24"
              style="overflow-y: hidden"
            >
              <el-container class="content-container">
                <router-view v-slot="{ Component }">
                  <transition
                    name="fade-height"
                    mode="out-in"
                    appear
                  >
                    <component :is="Component" />
                  </transition>
                </router-view>
              </el-container>
            </el-col>
          </el-row>
        </div>
      </section>
    </transition>
  </div>
</template>
<script>
// @ is an alias to /src
import { onUnmounted, onMounted, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import useChangePage from '@/composables/useChangePage'
import useCheckPage from '@/composables/useCheckPage'
import useFilterPage from '@/composables/useFilterPage'
import useOverflowCheck from '@/composables/useOverflowCheck'
export default {
  name: 'Safe',
  setup () {
    const affixPhoneFix = computed(() => {
      if (window.innerWidth > 769) {
        return '.affix-container'
      } else {
        return ''
      }
    })
    const store = useStore()
    const router = useRouter()
    const route = useRoute() // $router與$route
    // 頁面從第一畫面切換到第二畫面
    const { changePage } = useChangePage()
    // sidebar渲染，根據第一畫面選擇，篩選對應的列表給回傳v-for
    const { filteredPageData } = useFilterPage()
    // 頁面檢查，應對重新整理的狀況，抓取路由網址，即時做出相對應的渲染
    const { checkPage } = useCheckPage()
    // 使用composition api，沒有了beforeCreate和created生命週期，需要直接改寫在這裡
    checkPage(route)
    // 第二畫面，點擊左側標題欄標題，右側資料視窗渲染出對應的文章
    // 切換網頁址，切換麵包屑標題(最後一層)
    const changeSubPage = (link, title) => {
      router.push(link)
      store.commit('setPageTitle', title)
    }
    // commit(012047):修正切換頁面時，畫面不會跳回第一畫面的錯誤，在切換頁面，卸下元素時，初始化store裡的nowPage
    onUnmounted(() => {
      store.commit('setPage', '')
    })
    // 偵測左側sidebar按鈕的內容是否超出按鈕長度，有的話，給其加上跑馬燈的動畫
    const { checkOverflown } = useOverflowCheck()
    // 此處呼叫的用意是應對重新整理的狀況，另外一個呼叫點位在useChangePage裡，切換之後計時1秒等待渲染後呼叫
    onMounted(() => {
      checkOverflown()
    })

    return {
      filteredPageData,
      changePage,
      changeSubPage,
      affixPhoneFix
    }
  }
}
</script>
<style lang="scss" scoped>
$phones-media: 769px;
.fade-height-enter-active,
.fade-height-leave-active {
  transition: all 0.5s ease-out;
  max-height: 1000px;
}

.fade-height-enter-from,
.fade-height-leave-to {
  opacity: 0;
  max-height: 0px;
}
@media only screen and (max-width: $phones-media) {
  //手機版css
  .row {
    width: 60vw;
    margin: 0;
    flex-wrap: nowrap;
    display: inline-flex;
    overflow-x: scroll;
  }
  .Safe {
    background-image: url("../assets/Safe.jpg");
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
    min-height: 100vh;
    height: auto;
  }
  .main-section {
    background-size: cover;
    background-position: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    padding: 10px;
    padding-top: 17vmin;
  }
  ::v-deep .el-affix--fixed {
    //強迫el-affix加上的懸浮position規則(positoin: fixed)失效(強迫蓋過)
    position: static;
  }
  .inpage {
    width: 100%;
    margin-left: 0px !important;
    margin-right: 0px !important;
  }
  .page-sidebar {
    min-width: 100%;
    max-width: calc(100vw - 50px);
    margin-top: 5px;
    height: 30px;
    box-sizing: border-box;
    margin-left:0px;
    overflow-x: hidden;
  }
  .content-container {
    background-color: white;
    height: 100%;
    max-width: 100%;
    margin-top: 5px;
    margin-bottom: 30px;
    border-radius: 4px;
    border: var(--el-border-base);
    border-color: var(--el-button-border-color, var(--el-border-color-base));
    padding: 15px;
  }
  .main-title {
    font-size: 7vmin;
    color: white;
    filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.7));
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .phone-tips {
    color: white;
  }
  .card-title {
    margin-bottom: 0px;
    margin-top: 0px;
    line-height: 48px;
    font-size: 5vmin;
    background-color: #5c88a0;
    color: white;
  }
  .breadcrumb {
    margin-bottom: 5px;
    margin-top: 5px;
    font-size: 4vmin;
  }
  .el-breadcrumb {
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 4px;
    padding: 10px;
    margin-bottom: 10px;
  }
  ::v-deep .el-table {
    --el-table-border: 2px solid #96a0b9;
  }
  ::v-deep .el-table--border {
    border-right: 2px solid #96a0b9;
    border-bottom: 2px solid #96a0b9;
}
  ::v-deep .el-breadcrumb__item .el-breadcrumb__inner {
    font-weight: 400;
    color: white;
    &:hover {
      color: var(--el-color-primary);
    }
  }
}
@media only screen and (min-width: $phones-media) {
  :root {
    --overlen: -100%;
  }
  //電腦版css
  .row {
    width: 30vw;
    margin: 0;
    flex-wrap: nowrap;
    display: inline-flex;
  }
  .inpage {
    width: 80vmax;
    margin: 0;
    flex-wrap: nowrap;
  }
  .el-breadcrumb {
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 4px;
    padding: 10px;
    margin-bottom: 10px;
  }
  ::v-deep .el-breadcrumb__item .el-breadcrumb__inner {
    font-weight: 700;
    color: white;
    &:hover {
      color: var(--el-color-primary);
    }
  }
  ::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    font-weight: 700;
    color: white;
  }
  .page-sidebar {
    width: 100%;
    margin-top: 5px;
    height: 30px;
    margin-left: 0px;
    overflow: hidden;
  }
  .main-section {
    background-size: cover;
    background-position: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    padding-top: 10vmin;
    height: 100%;
  }
  .Safe {
    background-image: url("../assets/Safe.jpg");
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
    min-height: 100vh;
    height: auto;
  }
  .main-title {
    font-size: 5vmin;
    color: white;
    filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.7));
    margin-top: 20px;
    margin-bottom: 20px;
    br {
      display: none;
    }
  }
  .card-title {
    margin-bottom: 0px;
    margin-top: 0px;
    line-height: 48px;
    font-size: 2.5vmin;
    background-color: #5c88a0;
    color: white;
  }
  .phone-tips {
    display: none;
  } //(左右滑動選擇當前狀況)手機版專用提示，在電腦版設為隱藏
  .content-container {
    background-color: white;
    height: auto;
    width: 100%;
    margin-top: 5px;
    margin-bottom: 50px;
    border-radius: 4px;
    border: var(--el-border-base);
    border-color: var(--el-button-border-color, var(--el-border-color-base));
    padding: 15px;
  }
  ::v-deep .marquee {
    white-space: nowrap;
    overflow: hidden;
    box-sizing: border-box;
    span {
      --overflowLen: var(--overlen);
      display: inline-block;
      animation: marquee 4s linear infinite alternate;
    }
  }
  ::v-deep .el-table {
    --el-table-border: 2px solid #96a0b9;
  }
  ::v-deep .el-table--border {
    border-right: 2px solid #96a0b9;
    border-bottom: 2px solid #96a0b9;
}
  @keyframes marquee {
    0% {
      transform: translateX(0%);
    }
    100% {
      transform: translateX(var(--overflowLen));
    }
  }
}
</style>
